module.exports = __webpack_public_path__ + "img/logo.497b19c5.png";